import { render, staticRenderFns } from "./SummaryScore.vue?vue&type=template&id=7cbd1842"
import script from "./SummaryScore.vue?vue&type=script&lang=js"
export * from "./SummaryScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports